import { storage as i18n } from '@haohan/root-locales';

export const locales = [
	{
		flag: "/dist/img/flags/1x1/gb.svg",
		locale: "en"
	},
	{
		flag: "/dist/img/flags/1x1/ru.svg",
		locale: "ru"
	},
];

export const useMenu = (t: (msg: string) => string, lang = 'ru') => {
    return [
		{
			label: t("Characters"),
			path: 'characters',
		},
		lang === "ru" ? {
			label: t("Lessons"),
			path: 'lessons',
		} : null,
		{
			label: t("Radical table"),
			path: 'radicals',
		},
		{
			label: t("Games"),
			path: 'games',
			new: true
		},
		{
			label: t("Worksheet"),
			path: 'worksheet',
		},
	].filter(Boolean);
} 
